var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "tile is-parent pl-1" }, [
      _c("article", { staticClass: "tile is-child box" }, [
        _c("div", { staticClass: "columns is-flex is-align-items-center" }, [
          _vm._m(0),
          !_vm.hasError && _vm.showSavingStatus && !_vm.toastNotificationEnabled
            ? _c(
                "div",
                {
                  staticClass:
                    "column is-flex is-justify-content-flex-end is-align-items-center",
                },
                [
                  _vm.saving
                    ? _c("span", {
                        staticClass: "button is-loading is-white",
                        staticStyle: { height: "27px" },
                      })
                    : _c("span", { staticClass: "text has-text-success" }, [
                        _c("span", { staticClass: "mso mso-18px" }, [
                          _vm._v("check_circle"),
                        ]),
                      ]),
                  _c(
                    "span",
                    {
                      staticClass: "is-size-6",
                      class: _vm.saving
                        ? "has-text-warning"
                        : "has-text-success",
                    },
                    [_vm._v(_vm._s(_vm.savingStatus))]
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column" },
            [
              _c("PermissionTree", {
                attrs: { "permission-records": _vm.permissionRecords },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v("FlexiQuote Module")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }